<style scoped>
@import url('../../style/home/footer.css');
</style>

<template>
  <footer class="footer">
    <!-- 内容容器 -->
    <div class="footer-container">
      <!-- 左侧导航栏目 -->
      <div class="footer-nav">
        <div v-for="(column, index) in navColumns" :key="index" class="footer-column">
          <h3 class="column-title">{{ column.title }}</h3>
          <ul class="column-list">
            <li v-for="(item, i) in column.items" :key="i">
              <a href="#" class="column-link">{{ item }}</a>
            </li>
          </ul>
        </div>
      </div>

      <!-- 右侧客服与社交 -->
      <div class="footer-contact">
        <div class="hotline">
          <p class="hotline-label">客户服务热线：</p>
          <p class="hotline-number">0551-62614668</p>
        </div>
        <div class="social-icons">
          <a href="#" v-for="(icon, i) in socialIcons" :key="i" class="social-icon">
            <img :src="icon" alt="social" />
          </a>
        </div>
      </div>
    </div>

    <!-- 底部版权信息 -->
    <div class="footer-copyright">
      <div>
        <p>安徽省合肥市高新区黄山路602号合肥国家大学科技园A201</p>
        <p>皖ICP备2023015185号</p>
      </div>
      <div class="copyright-links">
        <a href="#">使用条款</a> |
        <a href="#">隐私政策</a> |
        <a href="#">网站地图</a>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'AppFooter',
  data() {
    return {
      // 底部导航栏数据
      navColumns: [
        {
          title: "我们的产品",
          items: ["皮肤镜图像处理工作站", "皮肤科", "医学美容科", "言语认知", "消化内科", "妇产科"],
        },
        {
          title: "应用方案",
          items: ["基层皮肤科建设方案", "白癜风光疗解决方案", "毛发专诊建设与管理方案", "光动力疗法及设备方案"],
        },
        {
          title: "创新智造",
          items: ["研发实力", "技术实力", "产品战略", "品牌荣誉"],
        },
        {
          title: "用户服务",
          items: ["质保注册", "授权查询", "联系我们"],
        },
        {
          title: "人才计划",
          items: ["社会人才", "校园人才"],
        },
        {
          title: "关于我们",
          items: ["企业发展", "企业经营", "服务与人才", "质量方针与执行力"],
        },
      ],
      // 社交图标数据
      socialIcons: [
        require("@/assets/images/logo-example.png"),
        require("@/assets/images/logo-example.png"),
        require("@/assets/images/logo-example.png"),
      ]
    }
  }
}
</script>